import "./Blog.module.css";
import Header from "@/reusable_sections/Header";
import InsightTecnici from "./sections/InsightTecnici";
import NewsletterSignup from "./sections/NewsletterSignup";
import PièDiPagina from "@/reusable_sections/Footer";
export default function BlogPage() {
  return <div>
      <Header />
      <InsightTecnici />
      <NewsletterSignup />
      <PièDiPagina />
    </div>;
}